import { type UseQueryResult, useQuery } from 'react-query';
import {
  OptionAwardApprovalService,
  // eslint-disable-next-line camelcase
  type PagedResultDto_OptionAwardListDto,
} from '../../services/wealthlane-award-services';
import { type TableParamsType } from '../../types/common';

const useGetOptionAwardApprovalList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  filterData: TableParamsType
): UseQueryResult<
  // eslint-disable-next-line camelcase
  PagedResultDto_OptionAwardListDto | undefined,
  unknown
> => {
  const {
    approvalStatusId,
    optionAcceptance,
    fromDate,
    toDate,
    createdFromDate,
    createdToDate,
    grantFromDate,
    grantToDate,
    employeeStatusId,
    isEarlyExercisable,
  } = filterData;

  const { filter, sorting, skipCount, maxResultCount, _force } = tableInfo;
  const optionStatus = 0;

  const OptionParticipantList = useQuery(
    [
      'getOptionAwardApprovalList',
      approvalStatusId,
      fromDate,
      toDate,
      employeeStatusId,
      optionStatus,
      optionAcceptance,
      createdFromDate,
      createdToDate,
      grantFromDate,
      grantToDate,
      isEarlyExercisable,
      filter,
      sorting,
      skipCount,
      maxResultCount,
      _force,
    ],
    async () => {
      return await handleRequest(
        OptionAwardApprovalService.getApiAwardApiAppOptionAwardApprovalOptionAwardList(
          approvalStatusId ?? [0],
          fromDate,
          toDate,
          createdFromDate,
          createdToDate,
          grantFromDate,
          grantToDate,
          employeeStatusId ?? [0],
          optionStatus,
          optionAcceptance,
          isEarlyExercisable,
          filter,
          sorting,
          skipCount,
          maxResultCount
        )
      );
    }
  );

  return OptionParticipantList;
};

export default useGetOptionAwardApprovalList;
